const DIRECTION = {
    col: "flex-col",
    row: "flex-row",
};

const WIDTH = {
    0: "",
    1: "w-1/12",
    2: "w-2/12",
    3: "w-3/12",
    4: "w-4/12",
    5: "w-5/12",
    6: "w-6/12",
    7: "w-7/12",
    8: "w-8/12",
    9: "w-9/12",
    10: "w-10/12",
    11: "w-11/12",
    12: "w-full",
    fit: "w-fit",
    full: "w-full",
    auto: "w-auto",
    "1/2": "w-1/2",
    "1/3": "w-1/3",
    "1/4": "w-1/4",
};

const COL_SPAN = {
    0: "",
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
    6: "col-span-6",
    7: "col-span-7",
    8: "col-span-8",
    9: "col-span-9",
    10: "col-span-10",
    11: "col-span-11",
    12: "col-span-12",
    13: "col-span-[span 13 / span 13]",
    14: "col-span-[span 14 / span 14]",
    15: "col-span-[span 15 / span 15]",
    16: "col-span-[span 16 / span 16]",
    17: "col-span-[span 17 / span 17]",
    18: "col-span-[span 18 / span 18]",
    19: "col-span-[span 19 / span 19]",
    20: "col-span-[span 20 / span 20]",
};
const GRID_COLS = {
    0: "",
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
    7: "grid-cols-7",
    8: "grid-cols-8",
    9: "grid-cols-9",
    10: "grid-cols-10",
    11: "grid-cols-11",
    12: "grid-cols-12",
    13: "grid-cols-13",
    14: "grid-cols-14",
    15: "grid-cols-15",
    16: "grid-cols-16",
    17: "grid-cols-17",
    18: "grid-cols-18",
    19: "grid-cols-19",
    20: "grid-cols-20",
};

const FLEX = {
    0: "",
    1: "flex-[1]",
    2: "flex-[2]",
    3: "flex-[3]",
    4: "flex-[4]",
    5: "flex-[5]",
    6: "flex-[6]",
    7: "flex-[7]",
    8: "flex-[8]",
    9: "flex-[9]",
    10: "flex-[10]",
    11: "flex-[11]",
    12: "flex-[12]",
};

const JUSTIFY_CONTENT = {
    start: "justify-start",
    center: "justify-center",
    end: "justify-end",
    between: "justify-between",
};

const ALIGN_ITEMS = {
    start: "items-start",
    left: "items-start",
    center: "items-center",
    end: "items-end",
    right: "items-end",
};

const TEXT_ALIGN = {
    start: "text-left",
    left: "text-left",
    center: "text-center",
    right: "text-right",
    end: "text-right",
};

const GAP = {
    0: "",
    1: "gap-1",
    2: "gap-2",
    4: "gap-4",
    6: "gap-6",
    8: "gap-8",
    10: "gap-10",
    12: "gap-12",
    14: "gap-14",
    16: "gap-16",
};

const PADDING = {
    0: "",
    1: "p-1",
    2: "p-2",
    4: "p-4",
    6: "p-6",
    8: "p-8",
    10: "p-10",
    12: "p-12",
    14: "p-14",
    16: "p-16",
};

const PADDING_X = {
    0: "",
    1: "px-1",
    2: "px-2",
    4: "px-4",
    8: "px-8",
    10: "px-10",
    12: "px-12",
    14: "px-14",
    16: "px-16",
};

const PADDING_Y = {
    0: "",
    1: "py-1",
    2: "py-2",
    4: "py-4",
    8: "py-8",
    10: "py-10",
    12: "py-12",
    14: "py-14",
    16: "py-16",
};

const PADDING_L = {
    0: "",
    1: "pl-1",
    2: "pl-2",
    3: "pl-3",
    4: "pl-4",
    5: "pl-5",
    6: "pl-6",
    7: "pl-7",
    8: "pl-8",
    9: "pl-9",
    10: "pl-10",
    11: "pl-11",
    12: "pl-12",
    13: "pl-[3.25rem]",
    14: "pl-14",
    15: "pl-[3.75rem]",
    16: "pl-16",
    17: "pl-[4.25rem]",
    18: "pl-[4.5rem]",
    19: "pl-[4.75rem]",
    20: "pl-[5rem]",
    21: "pl-[5.25rem]",
};

const PADDING_R = {
    0: "",
    1: "pr-1",
    2: "pr-2",
    3: "pr-3",
    4: "pr-4",
    5: "pr-5",
    6: "pr-6",
    7: "pr-7",
    8: "pr-8",
    9: "pr-9",
    10: "pr-10",
    11: "pr-11",
    12: "pr-12",
    13: "pr-[3.25rem]",
    14: "pr-14",
    15: "pr-[3.75rem]",
    16: "pr-16",
    17: "pr-[4.25rem]",
    18: "pr-[4.5rem]",
    19: "pr-[4.75rem]",
    20: "pr-[5rem]",
    21: "pr-[5.25rem]",
};

const COLOR_BACKGROUND = {
    black: "bg-black",
    white: "bg-white",
    darkgray: "bg-darkgray",
    gray: "bg-gray",
    lightgray: "bg-lightgray",
    blue: "bg-blue",
    success: "bg-success",
    error: "bg-error",
    info: "bg-info",
    warning: "bg-warning",
    yellow: "bg-[#ffff00]",
};

const COLOR_BORDER = {
    black: "border-black",
    white: "border-white",
    darkgray: "border-darkgray",
    gray: "border-gray",
    lightgray: "border-lightgray",
    blue: "border-blue",
    success: "border-success",
    error: "border-error",
    info: "border-info",
    warning: "border-warning",
};

const COLOR_TEXT = {
    black: "text-black",
    white: "text-white",
    darkgray: "text-darkgray",
    gray: "text-gray",
    lightgray: "text-lightgray",
    blue: "text-blue",
    success: "text-success",
    error: "text-error",
    info: "text-info",
    warning: "text-warning",
};

const BOLD_TEXT = {
    100: "font-thin",
    300: "font-light",
    500: "font-medium",
    700: "font-bold",
    900: "font-black",
};

const SIZE_TEXT = {
    xs: "text-xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl",
};

// fontSize: {
//     xs: "11px",
//     sm: "12px",
//     base: "13px",
//     lg: "14px",
//     xl: "16px",
//     "2xl": "18px",
//     "3xl": "20px",
// },

export {
    DIRECTION,
    WIDTH,
    COL_SPAN,
    FLEX,
    GAP,
    PADDING,
    PADDING_X,
    PADDING_Y,
    PADDING_R,
    PADDING_L,
    COLOR_BACKGROUND,
    COLOR_BORDER,
    COLOR_TEXT,
    JUSTIFY_CONTENT,
    ALIGN_ITEMS,
    GRID_COLS,
    BOLD_TEXT,
    SIZE_TEXT,
    TEXT_ALIGN,
};
